import { jsx as _jsx } from "react/jsx-runtime";
import { DsRemixIcon } from '../DsRemixIcon';
export const DsCheckboxDefaultProps = {
    color: 'secondary',
    icon: (_jsx(DsRemixIcon, { className: "ri-checkbox-blank-line", color: "inherit", fontSize: "inherit" })),
    checkedIcon: (_jsx(DsRemixIcon, { className: "ri-checkbox-fill", color: "inherit", fontSize: "inherit" })),
    indeterminateIcon: (_jsx(DsRemixIcon, { className: "ri-checkbox-indeterminate-fill", color: "inherit", fontSize: "inherit" })),
    size: 'small'
};
